//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        description: {
            type: String,
            default: ''
        }
    },

    data() {
        return {};
    }
};
